var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3497 0H9.12891C9.12891 2.2992 10.9923 4.16256 13.2915 4.16256H14.9897V5.80224C14.9916 8.09952 16.8531 9.96096 19.1494 9.96192V0.79968C19.1494 0.35808 18.7913 0 18.3497 0Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7872 4.59375H4.56641C4.56737 6.89103 6.42977 8.75247 8.72609 8.75343H10.4243V10.3989C10.4272 12.6962 12.2896 14.5557 14.5869 14.5557V5.39343C14.5878 4.95183 14.2298 4.59375 13.7872 4.59375Z",
    fill: "url(#paint0_linear_16093_204634)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2208 9.1875H0C0 11.4867 1.86336 13.3501 4.16256 13.3501H5.86656V14.9897C5.86848 17.2841 7.72608 19.1456 10.0214 19.1494V9.98718C10.0205 9.54558 9.6624 9.1875 9.2208 9.1875Z",
    fill: "url(#paint1_linear_16093_204634)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16093_204634",
    x1: 14.3904,
    y1: 4.60822,
    x2: 10.4926,
    y2: 8.67583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16093_204634",
    x1: 10.0864,
    y1: 9.23115,
    x2: 5.57734,
    y2: 13.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/jira.015c5d57234be0b35aabdc9c4e01ce22.svg";
export { ForwardRef as ReactComponent };